<template>
  <div class="partner-resumes-base-resumes__table-row  _head" :class="{_empty: isEmpty}">
    <APResumesBaseResumePageHeadRowPerson :name="$tResumesBaseResumes('Candidate')"
                                          :routeKey="FILTER_KEY_CANDIDATE"
                                          :apiLink="candidatesLink"
                                          class="partner-resumes-base-resumes__table-cell  _head  _candidate"/>

    <APResumesBaseResumePageHeadRowStatus :routeKeyStatus="FILTER_KEY_STATUS"
                                          :routeKeyRange="FILTER_KEY_RANGE"
                                          :apiLink="statusesLink"
                                          class="partner-resumes-base-resumes__table-cell  _head  _status"/>

    <APResumesBaseResumePageHeadRowPerson :name="$tResumesBaseResumes('Invited by')"
                                          :routeKey="FILTER_KEY_REFERRAL"
                                          :apiLink="inviterLink"
                                          class="partner-resumes-base-resumes__table-cell  _head  _referral"/>

    <div class="partner-resumes-base-resumes__table-cell  _head  _actions">

    </div>
  </div>
</template>

<script>
  import APResumesBaseResumePageHeadRowPerson from './APResumesBaseResumePageHeadRowPerson'
  import APResumesBaseResumePageHeadRowStatus from './APResumesBaseResumePageHeadRowStatus'
  import {mapGetters} from 'vuex'

  export default {
    name: 'APResumesBaseResumePageHeadRow',
    inject: [
      'FILTER_KEY_CANDIDATE',
      'FILTER_KEY_REFERRAL',
      'FILTER_KEY_STATUS',
      'FILTER_KEY_RANGE',
    ],
    props: {
      isEmpty: Boolean
    },
    components: {
      APResumesBaseResumePageHeadRowPerson,
      APResumesBaseResumePageHeadRowStatus,
    },
    computed: {
      ...mapGetters('user', [
        'isModerator'
      ]),
      candidatesLink() {
        if(this.isModerator) {
          return '/api/backoffice/resume-base/candidates-list'
        }

        return '/api/cabinet/agent/resume-base/candidates-list'
      },
      inviterLink() {
        if(this.isModerator) {
          return '/api/backoffice/resume-base/partners-list'
        }

        return '/api/cabinet/agent/resume-base/partners-list'
      },
      statusesLink() {
        if(this.isModerator) {
          return '/api/backoffice/resume-base/status-list'
        }

        return '/api/cabinet/agent/resume-base/status-list'
      },
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>
